/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UnavailabilitiesToSave } from 'src/shared/models/unavailabilities-to-save.interface';
import { UnavailabilitySummary } from 'src/shared/models/unavailability-summary.interface';
import { UnavailabilityReason } from 'src/shared/models/unavailability-reason.interface';
import { dateToFormatYearMonthDayFromDate } from '../../utils/date.utils';

@Injectable()
export class UnavailabilityService {
  url: string = `${environment.backend_url}/api/v1/unavailabilities`;

  constructor(private readonly http: HttpClient) {}

  saveUnavailabilities(
    unavailabilities: UnavailabilitiesToSave,
  ): Observable<any> {
    return this.http.post(`${this.url}/`, unavailabilities);
  }

  getUnavailabilities(
    startDate: Date,
    days: number,
  ): Observable<UnavailabilitySummary[]> {
    return this.http.get<UnavailabilitySummary[]>(
      `${this.url}/?days=${days}&startDay=${startDate.toISOString()}`,
    );
  }

  getUnavailabilityReasons(): Observable<UnavailabilityReason[]> {
    return this.http.get<UnavailabilityReason[]>(`${this.url}/reasons`);
  }

  retrieveNextOrPreviousOpenedDay(
    numberOfDays: number,
    day: Date,
    isForward: boolean,
  ): Observable<any> {
    return this.http.get(
      `${this.url}/retrieve-next-or-previous-working-days?numberOfDays=${numberOfDays}&day=${dateToFormatYearMonthDayFromDate(day)}&isForward=${isForward}`,
    );
  }
}
